import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { DsEarthingDevicesIP, SaveEventType, SaveStatusObj, SOModule, UserType, ValidationItem, ValidationSummary } from '../../../../shared/misc-classes';
import { DataService } from '../../../../shared/dataservice.service';
import { ValidationDialog } from '../../../../dialogs/validation-dialog/validation-dialog';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';

@Component({
  selector: 'ds-earthing-devices',
  templateUrl: './ds-earthing-devices.component.html',
  styleUrls: ['./ds-earthing-devices.component.css']
})
export class DsEarthingDevicesComponent implements OnInit, OnChanges {
  
    @Input() dsEarthingDevicesObj: DsEarthingDevicesIP;
    @Input() soLockObtained:boolean;
    @Input() accessLevel: Array<UserType>;
    @Output() updateDatasheet: EventEmitter<SaveStatusObj> = new EventEmitter();
    
    disableForm: boolean = false;
    inputDisableMessage: string = 'This form is not yet enabled';
    readonlyAccess : boolean = false;
    Hvr:any = {};
    hasAccessEE: boolean = false;
    hasAccessME: boolean = false;
    hasAccessPM: boolean = false;
    lockFields: boolean = false; // After HOM lock
  
    constructor(public _dataService: DataService, public dialog: MatDialog) { }
  
    ngOnInit(): void {
    }
    ngOnChanges(): void {
       this.disableForm = true;
      if(this.soLockObtained == false){
        this.inputDisableMessage = "You can't Edit";
      }
      else if (this.accessLevel.includes(this._dataService.userType) == false) {
      this.inputDisableMessage = "You don't have EDIT ACCESS.";
    }
      else {
        this.disableForm = false;
        // this.checkUserEnabled();
      }
      if(this._dataService.hasReadOnlyAccess){
        this.readonlyAccess = true;
      }
      this.hasAccessEE = this._dataService.userType === (UserType.ELECTRICAL_ENGINEERING) || this._dataService.userType === (UserType.MARKETING) || this._dataService.userType === (UserType.SUPER_ADMIN);
      this.hasAccessME = this._dataService.userType === (UserType.MECHANICAL_ENGINEERING) || this._dataService.userType === (UserType.MARKETING) || this._dataService.userType === (UserType.SUPER_ADMIN);
      this.hasAccessPM = this._dataService.userType === (UserType.PROJECT_MANAGEMENT) || this._dataService.userType === (UserType.MARKETING) || this._dataService.userType === (UserType.SUPER_ADMIN);
      if (!this.dsEarthingDevicesObj.parentSORef.isDatasheetSubOrderEnabled) {
        this.lockFields = false;
      }
      else {
        this.lockFields = true;
      }
  
    }
   
  sectionNoteChangePM(_event: any) {
    this.dsEarthingDevicesObj.sectionNotePM = _event.target.value;
  }
  sectionNoteChangeEE(_event: any) {
    this.dsEarthingDevicesObj.sectionNoteEE = _event.target.value;
  }
  sectionNoteChangeME(_event: any) {
    this.dsEarthingDevicesObj.sectionNoteME = _event.target.value;
  }

  saveDS(_submitToNextSection:boolean){
      if(this.updateDatasheet){
        this.updateDatasheet.emit(new SaveStatusObj(SOModule.Marketing, 
            (_submitToNextSection == true ? SaveEventType.Submit_To_Next:SaveEventType.Save_Data)));
      }
    }
    reloadData(){
      if(this.updateDatasheet){
        this.updateDatasheet.emit(new SaveStatusObj(SOModule.Marketing, SaveEventType.Reload_Data));
      }
    }

  showSoValidation() {
    let _validList: Array<ValidationItem> = [];

    if (this.hasAccessEE) {
      _validList.push(
        new ValidationItem("Earthing Device Bus Side", !!this.dsEarthingDevicesObj.edBus, " required to save Datasheet."),
        new ValidationItem("Earthing Device Cable Side", !!this.dsEarthingDevicesObj.edCable, " required to save Datasheet.")
      );
      if (this.dsEarthingDevicesObj.isEDBusApplicable) {
        _validList.push(new ValidationItem("Earthing Device Bus Side Detail", !!this.dsEarthingDevicesObj.edBusDetail, " required to save Datasheet."));
      }
      _validList.push(new ValidationItem("EE Note", !!this.dsEarthingDevicesObj.sectionNoteEE, " required to save Datasheet."));
    }
    if (this.hasAccessPM) {
      _validList.push(new ValidationItem("PM Note", !!this.dsEarthingDevicesObj.sectionNotePM, " required to save Datasheet."));
    }
    if (this.hasAccessME) {
      _validList.push(new ValidationItem("ME Note", !!this.dsEarthingDevicesObj.sectionNoteME, " required to save Datasheet."));
    }

    let vSummaryObj: ValidationSummary = new ValidationSummary("Validation Summary.", _validList);
    this.dialog.open(ValidationDialog, { width: '50%', data: vSummaryObj });
  }

  saveSOValidation(): boolean {
    if (this.hasAccessEE) {
      if (!this.dsEarthingDevicesObj.edBus || !this.dsEarthingDevicesObj.edCable ||
        !this.dsEarthingDevicesObj.sectionNoteEE) {
        return false;
      }
      if (this.dsEarthingDevicesObj.isEDBusApplicable && !this.dsEarthingDevicesObj.edBusDetail) return false;
    }
    if (this.hasAccessPM) {
      if (!this.dsEarthingDevicesObj.sectionNotePM) return false;
    }
    if (this.hasAccessME) {
      if (!this.dsEarthingDevicesObj.sectionNoteME) return false;
    }
    return true;
  }
}

